/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from "react";
import styled from "@xstyled/styled-components";
import { Draggable } from "react-beautiful-dnd";
import QuoteItem from "../TaskInput/Item";
import { grid } from "../../Constants";
import { StrictModeDroppable } from "../../hooks/Dropable";

export const getBackgroundColor = (isdraggingover, isdraggingfrom) => {
  if (isdraggingover) {
    return "rgba(0, 74, 35, 0)";
  }
  if (isdraggingfrom) {
    return "rgba(0, 74, 35, 0)";
  }
  return "#fff";
};

const Wrapper = styled.div`
  background-color: ${(props) =>
    getBackgroundColor(props.isdraggingover, props.isdraggingfrom)};
  display: flex;
  flex-direction: column;
  opacity: ${({ isDropDisabled }) => (isDropDisabled ? 0.5 : "inherit")};
  padding: ${grid}px;
  border: ${grid}px;
  padding-bottom: 0;
  transition:
    background-color 0.2s ease,
    opacity 0.1s ease;
  user-select: none;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 5px;
  flex: 1;
  min-height: 0;
`;

const DropZone = styled.div`
  min-height: min-content;
  max-height: 90%;
  padding-bottom: ${grid}px;
`;
const ScrollContainer = styled.div`
  overflow-x: hidden;
  overflow-y: scroll;
  min-height: min-content;
`;

const InnerQuoteList = function InnerQuoteList(props) {
  try {
    if (!props.tasks) return null;
    return props.tasks
      .filter((t) => t.completed === 0)
      .map((task, renderedIndex) => (
        <Draggable key={task.id} draggableId={task.id} index={renderedIndex}>
          {(dragProvided, dragSnapshot) => (
            <QuoteItem
              key={task.id}
              task={task}
              taskId={task.id}
              title={props.title}
              overlay={props.overlay}
              handleUrgencyChange={props.handleUrgencyChange}
              handleEstimateChange={props.handleEstimateChange}
              onDragEndSteps={props.onDragEndSteps}
              addStep={props.addStep}
              aiHelp={props.aiHelp}
              toggleOverlay={props.toggleOverlay}
              toggleSubTask={props.toggleSubTask}
              toggleStep={props.toggleStep}
              toggleDisplay={props.toggleDisplay}
              updateDescription={props.updateDescription}
              updateStep={props.updateStep}
              updateNotes={props.updateNotes}
              deleteStep={props.deleteStep}
              deleteSubtask={props.deleteSubtask}
              deleteObjective={props.deleteObjective}
              promoteStepToMoment={props.promoteStepToMoment}
              momentValues={props.momentValues}
              day={props.day}
              isdragging={dragSnapshot.isdragging}
              isgroupedover={Boolean(dragSnapshot.combineTargetFor)}
              provided={dragProvided}
            />
          )}
        </Draggable>
      ));
  } catch (error) {
    console.error("Error in InnerQuoteList: ", error);
    return null;
  }
};

function InnerList(props) {
  const { tasks, dropProvided, title, onDragEndSteps, viewType, aiHelp } =
    props;

  return (
    <div className="quotelist--container">
      <DropZone ref={dropProvided.innerRef}>
        <InnerQuoteList
          tasks={tasks}
          title={title}
          overlay={props.overlay}
          onDragEndSteps={onDragEndSteps}
          handleUrgencyChange={props.handleUrgencyChange}
          handleEstimateChange={props.handleEstimateChange}
          addStep={props.addStep}
          aiHelp={aiHelp}
          toggleSubTask={props.toggleSubTask}
          toggleStep={props.toggleStep}
          toggleOverlay={props.toggleOverlay}
          toggleDisplay={props.toggleDisplay}
          updateDescription={props.updateDescription}
          updateStep={props.updateStep}
          updateNotes={props.updateNotes}
          deleteStep={props.deleteStep}
          deleteSubtask={props.deleteSubtask}
          deleteObjective={props.deleteObjective}
          promoteStepToMoment={props.promoteStepToMoment}
          momentValues={props.momentValues}
          day={props.day}
          viewType={viewType}
        />
        {dropProvided.placeholder}
      </DropZone>
    </div>
  );
}

export default function QuoteList(props) {
  const {
    ignoreContainerClipping,
    internalScroll,
    scrollContainerStyle,
    isDropDisabled,
    isCombineEnabled,
    listId = "LIST",
    listType,
    style,
    tasks,
    title,
    useClone,
    onDragEndSteps,
    aiHelp,
    viewType,
  } = props;

  return (
    <StrictModeDroppable
      droppableId={listId}
      type={listType}
      ignoreContainerClipping={ignoreContainerClipping}
      isDropDisabled={isDropDisabled}
      isCombineEnabled={isCombineEnabled}
      renderClone={
        useClone
          ? (provided, snapshot, descriptor) => {
              const cloneTask = tasks[descriptor.source.index];
              return (
                <QuoteItem
                  task={cloneTask}
                  taskId={cloneTask?.id}
                  provided={provided}
                  isdragging={snapshot.isdragging}
                  isClone
                  title={title}
                  overlay={props.overlay}
                  onDragEndSteps={onDragEndSteps}
                  addStep={props.addStep}
                  aiHelp={aiHelp}
                  handleUrgencyChange={props.handleUrgencyChange}
                  handleEstimateChange={props.handleEstimateChange}
                  toggleSubTask={props.toggleSubTask}
                  toggleStep={props.toggleStep}
                  toggleOverlay={props.toggleOverlay}
                  toggleDisplay={props.toggleDisplay}
                  updateDescription={props.updateDescription}
                  updateNotes={props.updateNotes}
                  updateStep={props.updateStep}
                  deleteStep={props.deleteStep}
                  deleteSubtask={props.deleteSubtask}
                  deleteObjective={props.deleteObjective}
                  promoteStepToMoment={props.promoteStepToMoment}
                  momentValues={props.momentValues}
                  day={props.day}
                  viewType={viewType}
                />
              );
            }
          : null
      }
    >
      {(dropProvided, dropSnapshot) => (
        <Wrapper
          style={style}
          isdraggingover={dropSnapshot.isdraggingover}
          isDropDisabled={isDropDisabled}
          isdraggingfrom={Boolean(dropSnapshot.draggingFromThisWith).toString()}
          {...dropProvided.droppableProps}
        >
          {internalScroll ? (
            <ScrollContainer id="scrollContainer" style={scrollContainerStyle}>
              <InnerList
                tasks={tasks}
                dropProvided={dropProvided}
                title={title}
                overlay={props.overlay}
                handleUrgencyChange={props.handleUrgencyChange}
                handleEstimateChange={props.handleEstimateChange}
                onDragEndSteps={onDragEndSteps}
                addStep={props.addStep}
                aiHelp={aiHelp}
                toggleSubTask={props.toggleSubTask}
                toggleStep={props.toggleStep}
                toggleDisplay={props.toggleDisplay}
                toggleOverlay={props.toggleOverlay}
                updateDescription={props.updateDescription}
                updateStep={props.updateStep}
                updateNotes={props.updateNotes}
                deleteStep={props.deleteStep}
                deleteSubtask={props.deleteSubtask}
                deleteObjective={props.deleteObjective}
                viewType={props.viewType}
              />
            </ScrollContainer>
          ) : (
            <InnerList
              tasks={tasks}
              dropProvided={dropProvided}
              title={title}
              overlay={props.overlay}
              handleUrgencyChange={props.handleUrgencyChange}
              handleEstimateChange={props.handleEstimateChange}
              onDragEndSteps={onDragEndSteps}
              addStep={props.addStep}
              aiHelp={aiHelp}
              toggleSubTask={props.toggleSubTask}
              toggleStep={props.toggleStep}
              toggleOverlay={props.toggleOverlay}
              toggleDisplay={props.toggleDisplay}
              updateDescription={props.updateDescription}
              updateStep={props.updateStep}
              updateNotes={props.updateNotes}
              deleteStep={props.deleteStep}
              deleteSubtask={props.deleteSubtask}
              deleteObjective={props.deleteObjective}
              promoteStepToMoment={props.promoteStepToMoment}
              momentValues={props.momentValues}
              day={props.day}
              viewType={props.viewType}
            />
          )}
        </Wrapper>
      )}
    </StrictModeDroppable>
  );
}
